import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function timeAgo(date: Date): string {
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000)
  if (seconds < 60) return `${seconds}s ago`
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes} min ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  return `${days}d ago`
}

export function getLastSunday(): string {
  const today = new Date()
  const day = today.getDay()
  const diff = day === 0 ? 0 : day
  const lastSunday = new Date(today)
  lastSunday.setDate(today.getDate() - diff)
  return lastSunday.toISOString().split('T')[0]
}

export function getYesterday(): string {
  const yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  return yesterday.toISOString().split('T')[0]
}

export function getToday(): string {
  return new Date().toISOString().split('T')[0]
}

export function formatDateRange(startDate: string, endDate: string | null, reportType: string): string {
  if (!startDate) return ''

  const start = new Date(startDate + 'T00:00:00')
  const startDayName = start.toLocaleDateString('en-US', { weekday: 'long' })
  const startFormatted = start.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })

  if (reportType === 'range' && endDate) {
    const end = new Date(endDate + 'T00:00:00')
    const endDayName = end.toLocaleDateString('en-US', { weekday: 'long' })
    const endFormatted = end.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    const daysDiff = Math.ceil((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)) + 1
    return `${daysDiff} day${daysDiff !== 1 ? 's' : ''} from ${startDayName} ${startFormatted} to ${endDayName} ${endFormatted}`
  } else if (reportType === 'weekly') {
    const end = new Date(start)
    end.setDate(end.getDate() + 6)
    const endDayName = end.toLocaleDateString('en-US', { weekday: 'long' })
    const endFormatted = end.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    return `7 days from ${startDayName} ${startFormatted} to ${endDayName} ${endFormatted}`
  } else {
    return `1 day on ${startDayName} ${startFormatted}`
  }
}
